import { render, staticRenderFns } from "./TestJs.vue?vue&type=template&id=9f92693a&scoped=true&"
import script from "./TestJs.vue?vue&type=script&lang=js&"
export * from "./TestJs.vue?vue&type=script&lang=js&"
import style0 from "./TestJs.vue?vue&type=style&index=0&id=9f92693a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f92693a",
  null
  
)

export default component.exports